<template>
  <div class="tree-menu-item">
    <slot></slot>
    <div class="">
      <el-menu
        :default-active="activeIndex"
        :default-openeds="openedIndex"
        class="nav-menu"
        @open="handleOpen"
        @close="handleClose"
        @select="handleSelect"
        :unique-opened="true"
        router
      >
        <el-submenu
          v-for="menu in menus"
          :key="menu.id"
          :index="menu.id.toString()"
        >
          <template slot="title">
            <div class="nav-title white size-16 content_over">
              <i class="iconfont icon-shuju" />
              {{ $t(menu.name) }}
            </div>
          </template>
          <template v-for="submenu in menu.subMenus">
            <el-menu-item
              class="nav-menu-item"
              :class="$route.path == submenu.url ? 'active' : ''"
              v-if="
                submenu.url && submenu.type == 'link' && !submenu.isNewWindow
              "
              :key="submenu.id"
              :index="submenu.url"
              @click.native="submenu.isNewWindow ? OpenWindow(submenu.url) : ''"
            >
              <div class="nav-menu-item-title lightgray size-16 content_over">
                <i class="iconfont icon-icon" />
                {{ $t(submenu.name) }}
              </div>
            </el-menu-item>
            <el-menu-item
              class="nav-menu-item lightgray size-16"
              :class="$route.path == submenu.url ? 'active' : ''"
              v-if="
                submenu.url && submenu.type == 'link' && submenu.isNewWindow
              "
              :key="submenu.id"
              :index="submenu.url"
              @click.native="submenu.isNewWindow ? OpenWindow(submenu.url) : ''"
            >
              <div class="content_over">
                {{ $t(submenu.name) }}
              </div>
            </el-menu-item>
          </template>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
export default {
  name: "TreeMenuItem",
  props: ["menus", "activeIndex", "openedIndex"],
  mounted() {},
  methods: {
    init() {},
    OpenWindow(url) {
      window.open(url, "_blank");
    },
    handleSelect(index, indexPath) {
      let paths = index.split("-");
      if (paths.length > 1) {
        this.$store.commit("menu/setOpenedIndex", paths[length - 2]);
      }
      this.$store.commit("menu/setActiveIndex", index);
    },
    handleOpen(index, indexPath) {},
    handleClose(index, indexPath) {}
  }
};
</script>
<style scoped>
.tree-menu-item {
  /* text-align: left;
  margin-top: 49px;
  margin-left: 30%; */
}
.nav-title {
  /* font-weight: 700; */
  /* margin-top: 42px; */
}
.nav-title > i {
  color: #fff;
}
.nav-menu {
  border: none;
  /* background-color: #f0f0f0; */
  background-color: #222;
}
.nav-menu-item {
  /* color: #36383c; */
  /* color: #666; */
  padding: 12px 0;
  height: 100%;
  line-height: 1.5;
  white-space: normal;
}
.nav-menu-item.is-active {
  color: #666;
  /* background-color: #f0f0f0; */
  background-color: transparent;
}
.nav-menu-item:hover {
  color: #222;
  background-color: #76767b;
}
.nav-menu-item.active {
  color: #222;
  background-color: #76767b;
}
.nav-menu-item-title > i {
  color: #ddd;
}
</style>


